export const getFileContent = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsText(file, 'UTF-8');
    reader.onloadend = evt => resolve(evt.target.result);
  });
};
